import "./App.css";
import { useEffect, useState } from "react";
import Home from "./pages/Home";
import { Route, Routes } from "react-router-dom";
import CreateItem from "./pages/CreateItem";
import Navbar from "./components/Navbar";
import Menu from "./pages/Menu";
import { actionType } from "./context/reducer";
import { useStateValue } from "./context/StateProvider";
import { getAllFoodItems } from "./utils/firebaseFunctions";
import { AnimatePresence } from "framer-motion";
import Cart from "./pages/Cart";

function App() {
  const [{ foodItems, cartItems }, dispatch] = useStateValue();
  const [items, setItems] = useState([])

  const fetchFoodItems = async () => {
    await getAllFoodItems().then((data) => {
      dispatch({
        type: actionType.SET_FOOD_ITEMS,
        foodItems: data,
      });
    });
  };


  const addToCart =()=>{
    
    dispatch({
      type: actionType.SET_CART_ITEMS,
      cartItems: items
    })
    localStorage.setItem('cartItems', JSON.stringify(items))
  }
const handleBusket = (item)=>{
  setItems([...cartItems, item])
  
}
  useEffect(() => {
    addToCart()
  }, [items]);


  useEffect(() => {
    fetchFoodItems();
  }, []);

  return (
    <AnimatePresence exitBeforeEnter>
      <body className="">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home addToCart={addToCart} handleBusket={handleBusket}/>} />
          <Route path="/createItem" element={<CreateItem />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/menu" element={<Menu />} />
        </Routes>
      </body>
    </AnimatePresence>
  );
}

export default App;
